import { Observable, Subject } from 'rxjs';

export enum ControlType {
  text,
  select,
  radio,
  email,
  password,
  date,
  checkbox,
  age,
  ahv,
  phone
}

export class Control<T> {
  require = '';

  required = true;

  min?: number;

  private readonly change = new Subject<void>();
  get changed(): Observable<void> {
    return this.change.asObservable();
  }

  private visibility = true;

  constructor(
    public name: string,
    public placeholder: string,
    public type: ControlType,
    public value?: T
  ) {}

  setVisible(value: boolean): void {
    this.visibility = value;
  }
  isVisible(): boolean {
    return this.visibility;
  }
  isHidden(): boolean {
    return !this.isVisible();
  }

  refresh(): void {
    this.change.next();
  }

  setValue(value: T): void {
    this.value = value;
  }

  isValid(): boolean {
    return true;
  }
}
